module.exports = __webpack_public_path__ + "img/iv_b4_img3.3692c9b5.png";